import api from "./api";

/**
 * Upozornění na tomto zařízení (Web Push): počítač, Android, iPhone jen
 * s ProfitPilotem přidaným na plochu (Sdílet → Přidat na plochu, iOS 16.4+).
 * Server posílá na zařízení přihlášeného člověka; po odhlášení se odběr zruší.
 */
export const umiPush = () => typeof window !== "undefined"
  && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const jeIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const naPlose = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

let registrace = null;
export function zaregistrovat() {
  if (!("serviceWorker" in navigator)) return Promise.resolve(null);
  if (!registrace) registrace = navigator.serviceWorker.register("/sw.js").then(() => navigator.serviceWorker.ready).catch(() => null);
  return registrace;
}

function klicNaBajty(b64) {
  const s = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
}

/** "zapnuto" | "vypnuto" | "zakazano" (prohlížeč zakázal) | "ios-plocha" (nejdřív na plochu) | "nejde" */
export async function stavPush() {
  if (!umiPush()) return jeIos() && !naPlose() ? "ios-plocha" : "nejde";
  if (Notification.permission === "denied") return "zakazano";
  const reg = await zaregistrovat();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub && Notification.permission === "granted" ? "zapnuto" : "vypnuto";
}

/** Volat přímo z kliknutí — prohlížeč se zeptá na povolení jen po akci člověka. */
export async function zapnoutPush() {
  const povoleni = await Notification.requestPermission();
  if (povoleni !== "granted") return povoleni === "denied" ? "zakazano" : "vypnuto";
  const reg = await zaregistrovat();
  if (!reg) return "nejde";
  const { data } = await api.get("/api/push/klic");
  const sub = (await reg.pushManager.getSubscription())
    || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: klicNaBajty(data.klic) }));
  await api.post("/api/push/odber", sub.toJSON());
  return "zapnuto";
}

/** Po přihlášení: zařízení s povolením dostává upozornění právě přihlášeného člověka. */
export async function obnovitOdber() {
  if (!umiPush() || Notification.permission !== "granted") return;
  const reg = await zaregistrovat();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) await api.post("/api/push/odber", sub.toJSON()).catch(() => {});
}

/** Odhlášení: na tohle zařízení už upozornění tohoto člověka nechodí. */
export async function odhlasitPush() {
  if (!umiPush()) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) await api.post("/api/push/odhlasit", { endpoint: sub.endpoint });
  } catch { /* odhlášení nesmí spadnout */ }
}
